<template>
  <div class="empty-tips">
    <div class="empty-apply">
      <div style="margin-bottom:7px">
        <van-icon name="coupon-o" size="2rem" color="#A6A6A6" v-if="!isWarn" />
        <van-icon name="warn-o" size="3rem" color="#A6A6A6" v-else/>
      </div>
      <div v-for="(item,index) in tipsList" :key="index">{{ item }}</div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    tipsList: {
      type: Array,
      default: () => ['数据为空']
    },
    isWarn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
  }
}
</script>
<style lang="less" scoped>
.empty-tips {
 height: 100%;
 display: flex;
 justify-content: center;
 align-items: center;
}
.empty-apply {
  width: 200px;
  min-height: 200px;
  & > div {
    text-align: center;
    font-size: 0.9rem;
    color: #a6a6a6;
    // font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/EmptyTips.vue